import axios from 'axios';
import CryptoJs from 'crypto-js';
import { API_BASE_URL_IDENTITY_PROVIDER_SERVICE as API_BASE_URL_IDENTITY_PROVIDER_SERVICE, API_BASE_URL_IFOOD_SERVICE } from '../config/url-const.js'
import { API_BASE_URL_TRADER_SERVICE as API_BASE_URL_TRADER_SERVICE } from '../config/url-const.js'
import { API_BASE_URL_PRODUCT_SERVICE as API_BASE_URL_PRODUCT_SERVICE } from '../config/url-const.js'
import { isCanAddMetaData } from '../utils/roleAction';

class ApiService {
    validateUser(user) {
        const secretKey = '_zefdsuh123';
        let pwd = CryptoJs.AES.encrypt(user.password, secretKey).toString();
        //console.log("pwd is" + pwd);
        user.password = pwd;
        //console.log(" api service : " + API_BASE_URL_IDENTITY_PROVIDER_SERVICE + `/auth/login`, user)
        return axios.post(API_BASE_URL_IDENTITY_PROVIDER_SERVICE + `/auth/login`, user);
    }

    downloadExcelFile(data, name, organization) {
        const productIds = [];
        if (data != null) {
            data.forEach(element => {
                // console.log(element.id)
                productIds.push(element.id);
            });
        }

        //  console.log(productIds);
        if (productIds.length > 0) {
            return axios.post(API_BASE_URL_TRADER_SERVICE + `/api/files/download/traderfile?fileTemplate=trader&isValid=No` + "&" + 'productIds=' + productIds, data, {
                responseType: 'blob', headers: {
                    'traderName': name,
                    'traderOrganization': organization
                }
            })
        } else {
            return axios.post(API_BASE_URL_TRADER_SERVICE + `/api/files/download/traderfile?fileTemplate=trader&isValid=No`, data, {
                responseType: 'blob', headers: {
                    'traderName': name,
                    'traderOrganization': organization
                }
            })
        }

    }

    getTableHeader(tradername) {
        return axios.get(API_BASE_URL_TRADER_SERVICE + `/api/table/tradertableheader?traderName=` + tradername)
    }

    fetchUploadedRecord(traderNameToFetchRecord, traderOrganizationToFetchRecord, validOrNot) {
        if (traderOrganizationToFetchRecord.toLowerCase() == 'sysco') {
            var url = `/api/files/traderRecords`;
        } else if (traderOrganizationToFetchRecord.toLowerCase() == 'ecomarket') {
            var url = `/ecomarkettrader/traderRecords`;
        }
        // var url = `/api/files/traderRecords`;
        if (isCanAddMetaData()) {
            var headers = {
                traderName: traderNameToFetchRecord,
                traderOrganization: traderOrganizationToFetchRecord,
                isValid: validOrNot
            }
            return axios.get(API_BASE_URL_TRADER_SERVICE + url, { headers })

        } else {
            var headers = {
                traderName: traderNameToFetchRecord,
                traderOrganization: traderOrganizationToFetchRecord,
                isValid: validOrNot
            }
            return axios.get(API_BASE_URL_TRADER_SERVICE + url, { headers })
        }

    }
    getTraderDropDown() {
        return axios.get(API_BASE_URL_TRADER_SERVICE + `/api/table/gettraderlist`)
    }

    getIfoodTableHeader(traderName) {
        return axios.get(API_BASE_URL_PRODUCT_SERVICE + `/api/table/ifoodtableheader?traderName=` + traderName)
    }
    fetchiFoodTraderUploadedRecord(tradername) {
        return axios.get(API_BASE_URL_PRODUCT_SERVICE + `/product/IFoodtraderByTraderName?traderName=` + tradername)
    }

    getMlPredction(tradername) {
        return axios.get(API_BASE_URL_PRODUCT_SERVICE + `/prediction/predictionData?traderName=` + tradername)
    }

    updateTraderRecord(data) {
        return axios.put(API_BASE_URL_PRODUCT_SERVICE + `/product/IFoodtraderUpdate`, data);
    }

    fetchIfoodRecordByStatus(status, tradername, traderorganization) {
        return axios.get(API_BASE_URL_PRODUCT_SERVICE + `/product/IFoodtraderByStatus?status=` + status + `&traderName=` + tradername + `&traderOrganisation=` + traderorganization);
    }

    downloadProduct(selectedStatus, supcIdForAcceptedOrNewProducts, supcIdForRetunedProducts, tradername, traderorganization) {

        if (selectedStatus != 'RETURNED') {
            let ids = supcIdForAcceptedOrNewProducts
            return axios.post(API_BASE_URL_PRODUCT_SERVICE + `/export/bulkExport?status=` + selectedStatus + `&traderName=` + tradername + `&traderOrganisation=` + traderorganization, ids, { responseType: 'blob' });
        } else {
            let productIds = supcIdForRetunedProducts;
            return axios.post(API_BASE_URL_PRODUCT_SERVICE + `/export/returnedProducts?isValid=Yes&traderName=` + tradername + `&traderOrganisation=` + traderorganization, productIds, { responseType: 'blob' });
        }
    }

    getCurrentStepStatusById(uploadedId) {
        // console.log('id is'+uploadedId);
        var headers = {
            id: uploadedId
        }
        return axios.get(API_BASE_URL_TRADER_SERVICE + `/progress/getitdtloadtrackerbyid`, { headers })
    }

    getCurrentStepStatusByIdForIfood(uploadedId) {
        // console.log('id is'+uploadedId);
        var headers = {
            id: uploadedId

        }
        return axios.get(API_BASE_URL_IFOOD_SERVICE + `/progress/getitdtloadtrackerbyid`, { headers })
    }
    getEmailStatusByTrader(organisation, username, iteration) {
        var headers = {
            username: username,
            organisation: organisation
        }
        if (iteration == '1') {
            return axios.get(API_BASE_URL_TRADER_SERVICE + `/api/files/sendemailforTrader`, { headers })
        } else {
            return axios.get(API_BASE_URL_TRADER_SERVICE + `/api/files/sendemailforIfood`, { headers })
        }
    }

}
export default new ApiService();